<div class="row">
  <div class="col-sm-9">
    <app-page-title content="Users"></app-page-title>
  </div>
  <div class="col-sm-3">
    <app-search-box
      [(value)]="searchQuery"
      (searchSubmit)="onSearchQueryChange()"
    />
  </div>
</div>

@if (stats) {
  <div class="row">
    <div class="col-12">
      <div class="list-stats">
        <span class="list-stats__item">
          Active last month: <strong>{{ stats.activeLastMonth }}</strong>
        </span>
        <span class="list-stats__item">
          Active this month: <strong>{{ stats.activeThisMonth }}</strong>
        </span>
        <span class="list-stats__item">
          Total active: <strong>{{ stats.totalActive }}</strong>
        </span>
      </div>
    </div>
  </div>
}

<div class="card-box">
  <div class="page-filters">
    <div class="filter-field">
      <span class="filter-field__label">Role:</span>
      <app-user-group-select
        [groupIds]="groupIdsFilter"
        (userGroupsChange)="setUserListGroups($event)"
      >
      </app-user-group-select>
    </div>

    @if (user?.hasCompanies() && user.canListCompanies()) {
      <div class="filter-field">
        <span class="filter-field__label">Company:</span>
        <app-company-multiselect
          [hideWhenEmpty]="true"
          [companyIds]="companyIdsFilter"
          (companyChange)="setUserListCompanies($event)"
        >
        </app-company-multiselect>
      </div>
    }

    <div class="filter-field">
      <span class="filter-field__label">Team:</span>
      <app-team-multiselect
        [hideWhenEmpty]="true"
        [teamIds]="teamIdsFilter"
        (teamChange)="setUserListTeams($event)"
      >
      </app-team-multiselect>
    </div>
    <span *ngxPermissionsOnly="role.organizationAdmin" class="filter-checkbox">
      <p-checkbox
        inputId="activeUsers"
        binary="true"
        [ngModel]="showOnlyActiveUsers"
        (onChange)="toggleActiveUsers()"
      ></p-checkbox>
      <label for="activeUsers">Show active only</label>
    </span>

    @if (isClearFiltersVisible()) {
      <button
        pButton
        type="button"
        variant="text"
        class="new-filters__clear"
        (click)="clearFilters()"
      >
        <i class="pi pi-filter-slash"></i>
        Clear filters
      </button>
    }
  </div>
  <div class="list-header">
    <div class="row row--options">
      <div class="col-md-3" *ngxPermissionsOnly="role.organizationAdmin">
        <button pButton (click)="addNewItem()">
          <i class="pi pi-plus"></i> Add new user
        </button>
      </div>
    </div>
  </div>

  <app-email-editor #EmailEditorComponent [hidden]="!selectedUsers.length">
  </app-email-editor>

  <app-table
    [columns]="columns"
    [value]="items.items"
    [paginator]="items.totalItems > gridParams.limit"
    [loading]="loading"
    [rows]="gridParams.limit"
    [first]="gridParams.first"
    [totalRecords]="items.totalItems"
    (changePage)="loadPage($event.first / $event.rows + 1, $event.rows)"
    (sortRows)="sortGrid($event)"
    (rowClick)="openItem($event.model)"
    [(selection)]="selectedUsers"
    [selectable]="true"
  >
  </app-table>
  <app-table-selection-bar
    [selectedCount]="selectedUsers.length"
    [totalCount]="items.totalItems"
    (selectAll)="selectAll()"
    (clearSelection)="clearSelection()"
  >
    @if (selectedUsers.length) {
      <button
        pButton
        size="small"
        severity="primary"
        variant="text"
        (click)="
          EmailEditorComponent.isOpened()
            ? EmailEditorComponent.close()
            : EmailEditorComponent.open()
        "
      >
        <i class="pi pi-pencil"></i>
        {{
          EmailEditorComponent.isOpened() ? "Close email editor" : "Edit email"
        }}
      </button>
    }
    @if (
      EmailEditorComponent.isOpened() &&
      EmailEditorComponent.form.valid &&
      selectedUsers.length
    ) {
      <button
        pButton
        size="small"
        severity="primary"
        variant="text"
        [disabled]="emailLoading"
        (click)="sendEmail()"
      >
        <i class="pi pi-envelope"></i>
        Send
      </button>
    }
  </app-table-selection-bar>
</div>
